export function generateNumberOptionList(start: number, end: number) {
  const result: Array<{ label: string; value: number }> = []
  for (let i = start; i <= end; i += 1) {
    result.push({ label: `${i}`, value: i })
  }

  return result
}
